// @flow
// keep these css imports at the top of this file to ensure
// our styles are ordered correctly in the devbox bundle
import 'sail/sail.css';
// $FlowFixMe
import 'vendor/legacy/legacy.css';

import 'docs/setWebpackPublicPath';
import 'docs/polyfills';
import '@stripe/stripe-js';

import React from 'react';
import {hydrate} from 'react-dom';
import Prism from 'prismjs';
import {App} from 'docs/App';
import {
  configurePrismLanguages,
  isBrowser,
  initializeSentryClient,
} from 'docs/util';
import type {InitialState} from 'docs/types';

configurePrismLanguages(Prism);

export const appConstructor = (
  initialState: InitialState,
  helmetContext: Object,
  Component: any,
) => {
  const Root = Component || App;
  return <Root helmetContext={helmetContext} {...initialState} />;
};

const mountInBrowser = (Component) => {
  const initialState = window.__INITIAL_STATE__;
  const helmetContext = {};
  const app = appConstructor(initialState, helmetContext, Component);

  // $FlowFixMe
  hydrate(app, document.getElementById('root'));

  window.__INITIALIZED__ = true;
};

if (isBrowser) {
  const sentryUrl = window.__INITIAL_STATE__.sentryUrl;
  initializeSentryClient(sentryUrl);
  mountInBrowser(App);

  // $FlowFixMe
  if (process.env.NODE_ENV === 'development' && module.hot) {
    // $FlowFixMe
    module.hot.accept('./App', () => {
      const NewApp = require('./App').App;
      mountInBrowser(NewApp);
    });
  }
}
